export const WELCOME_MEDIA_URL = 'welcome_page/';
export const STORE_SWIRCHER_WELCOME_ID = 'WELCOME_STORE_WITCHER';
export const WELCOME_PAGE_CLASS = 'welcomePageNoScroll';
export const PLACEHOLDER_COUNTRY_NAME = '{{country}}';

export const TYPE_NONE = 'none';
export const TYPE_POPUP = 'popup';
export const TYPE_PAGE = 'page';
